import React from 'react';
import { useParams } from 'react-router-dom';

import ClientsUsersForm from '../components/Users/UsersForm';

function ClientsUsersFormPage() {
  const {
    id,
    userId,
  } = useParams();

  return (
    <ClientsUsersForm
      id={Number(userId)}
      clientId={Number(id)}
    />
  );
}

export default ClientsUsersFormPage;
